import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-obsidian text-white px-6 py-12">
      <div className="max-w-3xl mx-auto space-y-6 font-mono text-sm leading-relaxed">
        <Link to="/" className="kbd-label text-neon-cyan hover:text-white" data-testid="terms-back-link">← BACK TO HOME</Link>
        <h1 className="display-heading text-4xl font-black">Terms of Use</h1>
        <p className="text-white/50 text-xs">Last updated: {new Date().toISOString().slice(0, 10)}</p>

        <p>These terms govern your use of the Liquid RP Creators tool ("Service"), operated by Rage Holdings ("we"). By accessing the Service or joining the Liquid RP Discord via a referral link, you agree to these terms.</p>

        <h2 className="display-heading text-xl font-bold mt-6">1. Eligibility</h2>
        <p>You must be at least 13 years old (or the minimum age required by Discord in your country) to use the Service. Content creators applying for the referral program must comply with all applicable local laws and Discord&rsquo;s Terms of Service.</p>

        <h2 className="display-heading text-xl font-bold mt-6">2. Creator program</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Attribution is <span className="text-neon-cyan">first-touch</span> and permanent — a fan is credited to the creator whose invite they first joined through.</li>
          <li>Commission rates and attribution windows are set per creator and may be updated with reasonable notice.</li>
          <li>Payout thresholds and methods are agreed individually with each creator.</li>
          <li>Fraudulent activity (self-referrals, bot traffic, invite manipulation) results in forfeited commissions and program removal.</li>
        </ul>

        <h2 className="display-heading text-xl font-bold mt-6">3. Acceptable use</h2>
        <p>You agree not to: reverse-engineer the Service, attempt unauthorized access, misrepresent your identity, or use the Service for anything unlawful.</p>

        <h2 className="display-heading text-xl font-bold mt-6">4. Purchases &amp; refunds</h2>
        <p>All in-game purchases are processed by <span className="text-neon-cyan">Tebex</span> under their terms. Refunds and disputes must be handled through Tebex support directly. Refunded transactions are automatically deducted from creator commissions.</p>

        <h2 className="display-heading text-xl font-bold mt-6">5. Account &amp; data</h2>
        <p>You can request removal of your data at any time — see our <Link to="/privacy" className="text-neon-cyan hover:underline">Privacy Policy</Link>. We may suspend accounts that violate these terms.</p>

        <h2 className="display-heading text-xl font-bold mt-6">6. Service availability</h2>
        <p>The Service is provided "as is" without warranties. We may modify, suspend, or discontinue any part of the Service at any time.</p>

        <h2 className="display-heading text-xl font-bold mt-6">7. Liability</h2>
        <p>To the fullest extent permitted by law, we are not liable for indirect, incidental, or consequential damages arising from use of the Service.</p>

        <h2 className="display-heading text-xl font-bold mt-6">8. Changes</h2>
        <p>We may update these terms. Continued use after changes constitutes acceptance. Material changes will be communicated via the admin dashboard or Discord announcement.</p>

        <h2 className="display-heading text-xl font-bold mt-6">9. Contact</h2>
        <p>Email <a href="mailto:affiliate@rageholdings.com" className="text-neon-cyan hover:underline">affiliate@rageholdings.com</a>.</p>
      </div>
    </div>
  );
}
